import Vue from "vue";
import moment from "moment";
import { DEFAULT_DATE_TIME_FORMAT } from "@/config/Formats";

Vue.filter("dateTime", function (value: string): string {
  if (!value) return "";
  return moment(new Date(value)).format(DEFAULT_DATE_TIME_FORMAT);
});
